// @ts-nocheck
import React from "react";
import axios from "axios";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { useUsuarios } from "../State/UsuarioContext";
import { forwardRef } from 'react';
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import Typography from "@mui/material/Typography";
import SinapTheme from "../../styles/SinapTheme";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useBody } from "../../Body/state/BodyContext";
import { EXTENSION_MAIL_INSTITUCIONAL, RUTA_API_USUARIOS, URL_API_SIA } from "../../Contantes/Constantes";
import Divider from '@mui/material/Divider';
import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import ChipColor from "../../Componentes/ChipColor";
import { TiempoRestante } from "./TiempoRestante";
import KeyCloak from "../../Auth/Keycloak";
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import SinapThemev2 from "../../styles/SinapThemev2";
import PostAddIcon from '@mui/icons-material/PostAdd';
import { useHistory } from "react-router-dom";
import ModalCrearSolicitud from "./ModalCrearSolicitud";
import { Edit as EditIcon } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ModalBorrarUsuario } from "./ModalBorrarUsuario";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ModalModificarAlta from "./ModalModificarAlta";
import ModalDarAltaUsuario from "./ModalDarAltaUsuario";
import { useAuth } from "../../Auth/State/AuthContext";
import Tabla from "../../Componentes/Tabla";
import IconButton from "@mui/material/IconButton";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

const useStyles = makeStyles(theme => ({
    typografy: {
        marginTop: '2%',
        width: "100%",
        color: SinapTheme.palette.primary.main,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-start',
        '& > *': {
            margin: "8px",
        },
        flexGrow: 1,
        maxWidth: 752,
    },
    label: {
        paddingLeft: "16px",
        paddingTop: "14.4px"
    },
    header_forms: {
        textDecoration: 'underline'
    }
}))

export const PersonaIconPrimary = () => {
    return (<PersonAddIcon color="primary" />)
}

export const AltaDeUsuario = ({ }) => {
    let history = useHistory();
    const { altasPendientes, getAltasPendientes } = useUsuarios();
    const [botonesAcciones, setBotonesAcciones] = React.useState([]);
    const { setMessage, setSuccess } = useBody();
    const { user, hasRole } = useAuth();

    const columns = React.useMemo(
        () => [
            {
                accessorKey: 'nombre',
                header: 'Nombre',
                size: 150,
            },
            {
                accessorKey: 'apellido',
                header: 'Apellido',
                size: 150,
            },
            {
                accessorKey: 'frbaEmail',
                header: 'Email',
                size: 200,
            }
        ],
        []
    );

    const responsiveColumns = React.useMemo(
        () => [
            {
                accessorKey: 'frbaEmail',
                header: 'Email',
                size: 80,
                Cell: ({ cell }) => (
                    <span style={{
                        display: 'block',
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '200px'
                    }}>
                        {cell.getValue()}
                    </span>
                ),
            }
        ],
        []
    );

    const [openModalEliminar, setOpenModalEliminar] = React.useState(false);
    const [openModalModificar, setOpenModalModificar] = React.useState(false);
    const [openModalAlta, setOpenModalAlta] = React.useState(false);
    const matches = useMediaQuery('(min-width:1185px)');
    const [usuarioElegido, setUsuarioElegido] = React.useState({
        uid: '',
        nombre: '',
        apellido: '',
        frbaEmail: ''
    });
    const classes = useStyles();
    const actions = []

    if (hasRole(["ROLE_DAR_ALTA"]))
        actions.push({
            nombre: 'alta',
            icon: PersonaIconPrimary,
            tooltip: 'Dar de alta Usuario',
            onClick: (event, rowData) => abrirModalAlta(rowData)
        });

    if (hasRole(["ROLE_MODIFICAR_ALTA"]))
        actions.push({
            nombre: 'modificar',
            icon: EditIcon,
            tooltip: 'Modificar Usuario',
            onClick: (event, rowData) => abrirModalModificar(rowData)
        });

    if (hasRole(["ROLE_ELIMINAR_ALTA"]))
        actions.push({
            nombre: 'eliminar',
            icon: DeleteIcon,
            tooltip: 'Eliminar Usuario',
            onClick: (event, rowData) => abrirModalEliminar(rowData)
        });



    const abrirModalAlta = async (rowData) => {
        await setUsuarioElegido(rowData);
        setOpenModalAlta(true);
    }
    const abrirModalModificar = async (rowData) => {
        await setUsuarioElegido(rowData);
        setOpenModalModificar(true);
    }
    const abrirModalEliminar = async (rowData) => {
        await setUsuarioElegido(rowData);
        setOpenModalEliminar(true);
    }


    React.useEffect(() => {
        history.push({
            pathname: '/usuarios/alta',
            search: '?tab=2'
        })


        getAltasPendientes()
    }, [])

    return (
        <>
            <Box paddingX="20px">
                <Box display="flex" alignItems="center" justifyContent="space-between" my={2} >
                    <Typography
                        my={matches ? "40px" : "20px"}
                        mx="10px"
                        fontSize={matches ? "30px" : "28px"}
                    >
                        Alta de Usuarios
                    </Typography>
                    <div style={{ display: "flex", justifyContent: "center", marginRight: "10px" }}>
                        {botonesAcciones.map(boton => {
                            return boton
                        })}
                    </div>
                </Box>

                <Tabla
                    getRowId={(row) => row.uid}
                    columns={matches ? columns : responsiveColumns}
                    data={altasPendientes}
                    enableRowActions
                    enableFullScreenToggle={false}
                    enableColumnResizing={matches ? false : true}
                    layoutMode='grid'
                    positionActionsColumn='last'
                    renderRowActions={({ row, table }) => (
                        <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                            <IconButton
                                color="secondary"
                                disabled={!hasRole(["ROLE_DAR_ALTA"])}
                                onClick={() => {
                                    abrirModalAlta(row.id)
                                }}
                            >
                                <PersonaIconPrimary />
                            </IconButton>
                            <IconButton
                                color="secondary"
                                disabled={!hasRole(["ROLE_MODIFICAR_ALTA"])}
                                onClick={() => {
                                    abrirModalModificar(row.id)
                                }}
                            >
                                <EditIcon />
                            </IconButton>
                            <IconButton
                                color="secondary"
                                disabled={!hasRole(["ROLE_ELIMINAR_ALTA"])}
                                onClick={() => {
                                    abrirModalEliminar(row.id)
                                }}
                            >
                                <DeleteIcon style={{ color: "red" }} />
                            </IconButton>
                        </Box>
                    )}
                />
            </Box>

            <ModalDarAltaUsuario open={openModalAlta} onClose={() => setOpenModalAlta(false)} uid={usuarioElegido} />
            <ModalBorrarUsuario open={openModalEliminar} onClose={() => setOpenModalEliminar(false)} uid={usuarioElegido} />
            <ModalModificarAlta open={openModalModificar} onClose={() => setOpenModalModificar(false)} uid={usuarioElegido} />
        </>
    )
}